"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useRowGetter = function (data, itemsCount, onLastRow) {
    var rowGetter = (0, react_1.useCallback)(function (_a) {
        var index = _a.index;
        if (index === itemsCount - 1)
            onLastRow();
        return (data && index < itemsCount) ? data[index] : null;
    }, [data, itemsCount, onLastRow]);
    return { rowGetter: rowGetter };
};
exports.default = useRowGetter;
